import React from "react";
import { Instagram, YouTube, LinkedIn } from "@mui/icons-material";
import XIcon from "@mui/icons-material/X";

const HeroSection = () => {
  const socials = [
    {
      href: "https://store.steampowered.com/app/4553750/Puppel_Show",
      icon: (
        <svg viewBox="0 0 65 65" fill="currentColor">
          <path d="M30.31 23.985l.003.158-7.83 11.375c-1.268-.058-2.54.165-3.748.662a8.14 8.14 0 0 0-1.498.8L.042 29.893s-.398 6.546 1.26 11.424l12.156 5.016c.6 2.728 2.48 5.12 5.242 6.27a8.88 8.88 0 0 0 11.603-4.782 8.89 8.89 0 0 0 .684-3.656L42.18 36.16l.275.005c6.705 0 12.155-5.466 12.155-12.18s-5.44-12.16-12.155-12.174c-6.702 0-12.155 5.46-12.155 12.174zm-1.88 23.05c-1.454 3.5-5.466 5.147-8.953 3.694a6.84 6.84 0 0 1-3.524-3.362l3.957 1.64a5.04 5.04 0 0 0 6.591-2.719 5.05 5.05 0 0 0-2.715-6.601l-4.1-1.695c1.578-.6 3.372-.62 5.05.077 1.7.703 3 2.027 3.696 3.72s.692 3.56-.01 5.246M42.466 32.1a8.12 8.12 0 0 1-8.098-8.113 8.12 8.12 0 0 1 8.098-8.111 8.12 8.12 0 0 1 8.1 8.111 8.12 8.12 0 0 1-8.1 8.113m-6.068-8.126a6.09 6.09 0 0 1 6.08-6.095c3.355 0 6.084 2.73 6.084 6.095a6.09 6.09 0 0 1-6.084 6.093 6.09 6.09 0 0 1-6.081-6.093z" />
        </svg>
      ),
      label: "Steam",
    },
    {
      href: "https://www.instagram.com/dointogethergames/",
      icon: <Instagram />,
      label: "Instagram",
    },
    {
      href: "https://x.com/dointogether",
      icon: <XIcon />,
      label: "X",
    },
    {
      href: "https://www.youtube.com/@DoinTogether",
      icon: <YouTube />,
      label: "YouTube",
    },
    {
      href: "https://www.linkedin.com/company/dointogethergames/",
      icon: <LinkedIn />,
      label: "LinkedIn",
    },
  ];

  return (
    <section id="home" className="hero">
      {/* Floating decorative elements */}
      <div className="hero__float-decor hero__float-decor--1" />
      <div className="hero__float-decor hero__float-decor--2" />

      <h1 className="hero__greeting">HELLO</h1>
      <p className="hero__subtitle">We are doin' something together.</p>

      <div className="hero__socials">
        {socials.map((social) => (
          <a
            key={social.label}
            href={social.href}
            target="_blank"
            rel="noopener noreferrer"
            className="hero__social-btn"
            aria-label={social.label}
          >
            {social.icon}
          </a>
        ))}
      </div>
    </section>
  );
};

export default HeroSection;
